import React from 'react';
import { objetivoText, siteConfig } from '../../data/mock';
import { MessageCircle, ArrowRight } from 'lucide-react';

const ObjetivoSection = () => {
    const whatsappLink = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(siteConfig.whatsappMessage)}`;

    return (
        <section className="py-24 bg-white relative overflow-hidden">
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid md:grid-cols-2 gap-12 items-center">

                    {/* Left Column: Text & CTA */}
                    <div className="text-center md:text-left">
                        {/* Title */}
                        <h2 className="text-4xl md:text-5xl text-[#24293f] mb-8 leading-tight font-bold">
                            {objetivoText.headline}
                        </h2>

                        {/* Paragraphs */}
                        <div className="space-y-6 mb-10">
                            {objetivoText.paragraphs.map((text, index) => (
                                <p key={index} className="text-xl text-[#24293f] leading-relaxed font-medium">
                                    {text}
                                </p>
                            ))}
                        </div>

                        {/* CTA Button */}
                        {/* CTA Button - Desktop */}
                        <div className="hidden md:block">
                            <a
                                href={whatsappLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="group inline-flex items-center justify-center gap-3 bg-[#32D74B] hover:bg-[#28b03d] text-white px-5 py-3 text-sm md:px-8 md:py-4 md:text-lg rounded-lg font-bold uppercase tracking-wide transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-green-500/25"
                            >
                                <MessageCircle className="w-5 h-5" />
                                {siteConfig.ctaText}
                                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                            </a>
                        </div>
                    </div>

                    {/* Right Column: Blue Cards */}
                    <div className="space-y-6">
                        {objetivoText.cards.map((card, index) => (
                            <div key={index} className="bg-[#24293f] rounded-2xl p-8 text-white shadow-xl">
                                <h3 className="text-xl font-bold mb-4 text-[#c9a962]">
                                    {card.title}
                                </h3>
                                {card.subtitle && (
                                    <p className="font-semibold mb-4 text-white/90">
                                        {card.subtitle}
                                    </p>
                                )}

                                {card.items && (
                                    <ul className="space-y-2 mb-6 ml-4 list-disc text-white/80">
                                        {card.items.map((item, i) => (
                                            <li key={i}>{item}</li>
                                        ))}
                                    </ul>
                                )}

                                {card.conclusion && (
                                    <p className="text-white/80 italic border-l-4 border-[#c9a962] pl-4">
                                        {card.conclusion}
                                    </p>
                                )}

                                {card.description && (
                                    <p className="text-white/80 leading-relaxed">
                                        {card.description}
                                    </p>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* CTA Button - Mobile */}
                    <div className="md:hidden text-center mt-6">
                        <a
                            href={whatsappLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group inline-flex items-center justify-center gap-3 bg-[#32D74B] hover:bg-[#28b03d] text-white px-5 py-3 text-sm rounded-lg font-bold uppercase tracking-wide transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-green-500/25 w-full"
                        >
                            <MessageCircle className="w-5 h-5" />
                            {siteConfig.ctaText}
                            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                        </a>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default ObjetivoSection;
